import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import { CssBaseline } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';

import App from './App';
import AppStateProvider, { useAppState } from './state';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import ErrorDialog from './components/ErrorDialog/ErrorDialog';
import LoginPage from './components/LoginPage/LoginPage';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import GuestJoinScreen from './components/GuestJoinScreen/GuestJoinScreen';
import theme from './theme';
import './types';
import { ChatProvider } from './components/ChatProvider';
import { VideoProvider } from './components/VideoProvider';
import useConnectionOptions from './utils/useConnectionOptions/useConnectionOptions';
import UnsupportedBrowserWarning from './components/UnsupportedBrowserWarning/UnsupportedBrowserWarning';
import { setPageTitleByDomain } from './utils/titleManager';

const VideoApp = () => {
  const { error, setError } = useAppState();
  const connectionOptions = useConnectionOptions();

  return (
    <VideoProvider options={connectionOptions} onError={setError}>
      <ErrorDialog dismissError={() => setError(null)} error={error} />
      <ChatProvider>
        <App />
      </ChatProvider>
    </VideoProvider>
  );
};

// Guest App wrapper - similar to VideoApp but without PrivateRoute restrictions
const GuestApp = () => {
  const { error, setError } = useAppState();
  const connectionOptions = useConnectionOptions();

  return (
    <VideoProvider options={connectionOptions} onError={setError}>
      <ErrorDialog dismissError={() => setError(null)} error={error} />
      <ChatProvider>
        <App />
      </ChatProvider>
    </VideoProvider>
  );
};

// ReactDOM.render(
//   <MuiThemeProvider theme={theme}>
//     <CssBaseline />
//     <UnsupportedBrowserWarning>
//       <Router>
//         <AppStateProvider>
//           <Switch>
//             <Route path="/guest">
//               <VideoApp />
//             </Route>
//             <Route path="/login">
//               <LoginPage />
//             </Route>
//             <PrivateRoute exact path="/">
//               <VideoApp />
//             </PrivateRoute>
//             <PrivateRoute path="/room/:URLRoomName">
//               <VideoApp />
//             </PrivateRoute>
//             <Redirect to="/" />
//           </Switch>
//         </AppStateProvider>
//       </Router>
//     </UnsupportedBrowserWarning>
//   </MuiThemeProvider>,
//   document.getElementById('root')
// );

const RootApp = () => {
  useEffect(() => {
    setPageTitleByDomain();
  }, []);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <UnsupportedBrowserWarning>
        <Router>
          <AppStateProvider>
            <Switch>
              <Route path="/guest">
                <VideoApp />
              </Route>
              <Route path="/login">
                <LoginPage />
              </Route>
              <PrivateRoute exact path="/">
                <VideoApp />
              </PrivateRoute>
              <PrivateRoute path="/room/:URLRoomName">
                <VideoApp />
              </PrivateRoute>
              <Redirect to="/" />
            </Switch>
          </AppStateProvider>
        </Router>
      </UnsupportedBrowserWarning>
    </MuiThemeProvider>
  );
};

ReactDOM.render(<RootApp />, document.getElementById('root'));
